module.exports = __webpack_public_path__ + "ba.svg?08574dd3e584a45c50c666908c63f124";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ba.svg
// module id = 943
// module chunks = 27